var _excluded = ["children", "text", "icon", "iconLabel", "direction", "align", "variant", "defaultOpen", "showArrow", "hasPortal", "onOpenChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { forwardRef, slideDown, slideUp, styled } from '@grupoboticario/flora-react-system';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { AccessibleIcon } from '@radix-ui/react-accessible-icon';
import { Text } from '@grupoboticario/flora-react-text';
var DEFAULT_TOOLTIP_ICON_LABEL = 'Ícone do balão de informações';
var StyledTooltipContent = styled(TooltipPrimitive.Content, {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '$backgroundAltSecondary',
  color: '$nonInteractiveAltPredominant',
  minHeight: 48,
  gap: '$2',
  padding: '$4',
  borderRadius: '$small',
  animationDuration: '.3s',
  animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
  zIndex: '1',
  maxWidth: '272px',
  '&[data-side="top"]': {
    animationName: slideUp
  },
  '&[data-side="bottom"]': {
    animationName: slideDown
  },
  '& svg[data-tooltip-arrow]': {
    fill: '$nonInteractivePredominant'
  },
  '& > svg': {
    flexShrink: 0,
    size: 13
  },
  variants: {
    variant: {
      alt: {
        backgroundColor: '$backgroundPrimary',
        color: '$nonInteractivePredominant',
        '& svg[data-tooltip-arrow]': {
          fill: '$backgroundPrimary'
        }
      }
    }
  }
});
var TooltipTrigger = forwardRef((_ref, forwardedRef) => {
  var {
    children,
    trigger
  } = _ref;
  var TriggerComponent = TooltipPrimitive.Trigger;
  return /*#__PURE__*/React.createElement(TriggerComponent, {
    ref: forwardedRef,
    type: null,
    asChild: true,
    onFocus: () => trigger(true),
    onMouseEnter: () => trigger(true),
    onBlur: () => trigger(false),
    onMouseLeave: () => trigger(false)
  }, children);
});
/**
 * @component
 * @name Tooltip
 * @description Tooltip component
 * @tutorial https://flora.gb.tech/docs/components/core/tooltip
 */

export var Tooltip = forwardRef((props, forwardedRef) => {
  var {
    children,
    text = '',
    icon,
    iconLabel = DEFAULT_TOOLTIP_ICON_LABEL,
    direction = 'top',
    align = 'center',
    variant,
    defaultOpen = false,
    showArrow = true,
    hasPortal = false,
    onOpenChange
  } = props,
      restProps = _objectWithoutPropertiesLoose(props, _excluded);

  var TooltipContentWrapper = hasPortal ? TooltipPrimitive.Portal : 'div';
  var [opened, setOpened] = React.useState(defaultOpen);
  return /*#__PURE__*/React.createElement(TooltipPrimitive.Provider, null, /*#__PURE__*/React.createElement(TooltipPrimitive.Root, {
    open: opened,
    delayDuration: 0,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement(TooltipTrigger, {
    trigger: setOpened
  }, children), /*#__PURE__*/React.createElement(TooltipContentWrapper, null, /*#__PURE__*/React.createElement(StyledTooltipContent, _extends({}, restProps, {
    variant: variant,
    side: direction,
    align: align,
    alignOffset: -18
  }), icon && /*#__PURE__*/React.createElement(AccessibleIcon, {
    label: iconLabel
  }, icon), /*#__PURE__*/React.createElement(Text, {
    size: "exceptionsAuxiliarRegular",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), showArrow && /*#__PURE__*/React.createElement(TooltipPrimitive.Arrow, {
    "data-tooltip-arrow": true,
    offset: 25,
    width: 16,
    height: 8
  })))));
});
//# sourceMappingURL=Tooltip.js.map